import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import Link from 'components/Link';
import makeRequest from 'utils/makeRequest';
import Video from 'components/Video/VideoLoader';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import { sendGaThroughProps } from 'helpers/analytics/sendGaThroughProps';
import InViewObserver from 'components/InViewObserver';
import { addNextVideoMsid } from 'routes/home/redux';
import _get from 'lodash.get';
import Card from 'components_v2/common/CardV2';
import Slider from 'react-slick';
import InterSectionBorder from 'components_v2/common/InterSectionBorder';
import LoaderSpinner from 'components_v2/common/LoaderSpinner';
import s from './VideoWidget.scss';

class VideoWidget extends React.Component {
  constructor(props) {
    super();
    this.state = {
      slikeNextVideoAutoPlayed: false,
      navigation: [],
      activeTab: 0,
      // sectionName: '',
    };
    this.handleVideoClick = this.handleVideoClick.bind(this);
    this.label = '';
    if (props.isRHSWidgetAS) this.gaLabel = 'ArticleShow';
    else if (props.isRHSWidgetLB) this.gaLabel = 'LiveBlog';
    else if (props.isRHSWidgetPS) this.gaLabel = 'Photostory';
    else this.gaLabel = '';
  }

  componentDidMount() {
    for (let i = 0; i < this?.props?.breadCrumbData.length; i += 1) {
      this.label = `${this.label}${this.label === `` ? `` : `/`}${
        this.props.breadCrumbData[i]?.label
      }`;
    }
  }

  playOnLoad = () => {
    const { sectionData = {} } = this.props;
    if (this.props.playerConfig?.playOnLoad && sectionData?.items[0]?.id) {
      this.markPlaying(sectionData.items[0].id);
    }
  };

  loadNavigationData() {
    const { sectionData = {}, isRHSWidgetPS } = this.props;
    if (sectionData?.navigation) {
      this.setState({
        navigation: sectionData.navigation,
      });
    } else if (sectionData?.subSections?.dataUrl) {
      this.fetchNavigation(sectionData.subSections.dataUrl);
    }
    const wu = typeof window !== 'undefined' ? window?.location?.href : '';
    if (!isRHSWidgetPS) {
      this.sendGA(
        'VideoPlayer_Web_TOI',
        `View_VideoPlayerRHS`,
        `${this.gaLabel}_${this.label}_LP_${wu}`,
      );
    }
  }

  fetchNavigation(dataUrl) {
    if (!dataUrl) {
      return;
    }
    dataUrl = __PROD__ ? dataUrl : dataUrl.replaceAll('timesofindia', 'toidev');
    makeRequest
      .get(dataUrl, { isMobile: this.props.isMobile }, 'skipfeedengine')
      .then(data => {
        if (
          data &&
          data.data &&
          data.data.items &&
          data.data.items.length > 0
        ) {
          this.setState({
            navigation: data.data.items,
          });
        }
      });
  }

  sendGA = (actualCategory, actualAction, actualLabel) => {
    if (actualAction && actualAction.includes('View')) {
      analyticsWrapper(
        'gaAndGrx',
        'send',
        'event',
        actualCategory,
        actualAction,
        actualLabel,
        { nonInteraction: 1 },
      );
    } else {
      analyticsWrapper(
        'gaAndGrx',
        'send',
        'event',
        actualCategory,
        actualAction,
        actualLabel,
      );
    }
  };

  handleVideoClick(event, clickedVideoItem, index) {
    event.preventDefault();
    this.markPlaying(clickedVideoItem, false);
    if (typeof window?.grx_module?.hitgrxPageviewReact === 'function') {
      window.grx_module.hitgrxPageviewReact(false, clickedVideoItem?.wu);
    }
    const { sectionData } = this.props;
    if (this.props.isRHSWidgetPS) {
      analyticsWrapper('ga4', {
        event: 'user_click',
        type: 'video_rhs_widget',
        category: 'video_click',
        story_no: `${index}`,
      });
    } else if (
      sectionData &&
      sectionData.name === 'etimes_video_widget' &&
      index
    ) {
      sendGaThroughProps({
        data: {
          gaAction: 'click-RHS-videos',
          gaLabel: `${index}-${clickedVideoItem?.wu}`,
        },
      });
    } else {
      this.sendGA(
        'VideoPlayer_Web_TOI',
        `Click_VideoPlayerRHS_Playlist_P${clickedVideoItem?.gaindex}`,
        `${this.gaLabel}_${this.label}_LP_${typeof window !== 'undefined' &&
          window?.location?.href}_${clickedVideoItem?.wu}`,
      );
    }
  }

  onTabsChange = (ev, params) => {
    ev.preventDefault();
    const name = params?.clickedItem?.ganame?.replace(' ', '');
    const wu = typeof window !== 'undefined' ? window?.location?.href : '';
    const { sectionData = { id: '' } } = this.props;
    const sectionId = sectionData.id;
    this.props.loadAjaxSectionData({ ...params, sectionId }, params.i);
    this.setState({
      activeVideo: {},
      activeTab: params.i,
    });
    this.sendGA(
      'VideoPlayer_Web_TOI',
      `Click_VideoPlayerRHS_${name}`,
      `${this.gaLabel}_${this.label}_LP_${wu}`,
    );
  };

  getNextVideosMsidArray = () =>
    this.props.sectionData.items.map(item => item.id);

  markPlaying = (data, slikeNextVideoAutoPlayed = true) => {
    const playingVideoMsid = typeof data === 'object' ? data && data.id : data;
    const activeVideoArray = this.props.sectionData.items.filter(
      video => video.id === playingVideoMsid,
    );
    const activeVideo = activeVideoArray[0];
    if (!(typeof activeVideo === 'object' && activeVideo.id)) {
      return;
    }
    this.setState({
      activeVideo,
      slikeNextVideoAutoPlayed,
    });
  };

  setNextVideo = data => {
    const nextVideomsidArray = this.getNextVideosMsidArray();
    const oldMsid = data && data.id;
    const nextVideoIndex = nextVideomsidArray.indexOf(oldMsid) + 1;
    const ind = nextVideoIndex < nextVideomsidArray.length ? nextVideoIndex : 0;
    const newMsid = nextVideomsidArray[ind];
    const playerData = this.getSlikeIdAndPlayerIdFromMsid(newMsid);
    const newSlikeId = playerData.slikeId;
    const newPlayerId = playerData.playerId;
    this.props.addNextVideoMsid(newMsid, newSlikeId, newPlayerId);
    this.markPlaying(newMsid, false);
  };

  getPlayerType = playerType => {
    if (!playerType) {
      return '';
    }
    let playerTypeVal = '';
    switch (playerType) {
      case 'slike':
        playerTypeVal = '24';
        break;
      case 'youtube':
        playerTypeVal = '10';
        break;
      default:
        playerTypeVal = playerType;
    }
    return playerTypeVal;
  };

  getSlikeIdAndPlayerIdFromMsid(msid) {
    const playerData = {};
    const { sectionData } = this.props;
    if (sectionData && Array.isArray(sectionData.items)) {
      const { items } = sectionData;
      for (let i = 0; i < items.length; i += 1) {
        if (items[i].id === msid) {
          playerData.slikeId = items[i].playerId;
          playerData.playerId = this.getPlayerType(items[i].playerType);
          break;
        }
      }
    }
    return playerData;
  }

  videoEventListener = (messageName, data) => {
    const videoEvent = data ? data[1] : '';
    switch (videoEvent) {
      case 'VIDEOVIEW':
        break;
      case 'VIDEOEND':
        this.setNextVideo(this.state.activeVideo);
        break;
      default:
      // console.log('messageName', videoEvent);
    }
  };
  viewMore = tab => {
    const name = tab?.name?.replace(' ', '_');
    this.sendGA('VideoPlayer_Web_TOI', 'Click-More_Videos', name);
  };
  getListItem = (section, i) => (
    <li
      key={`${i}video`}
      onClick={e =>
        this.onTabsChange(e, {
          clickedItem: section,
          i,
        })
      }
      className={this.state.activeTab === i ? s.active : ''}
    >
      {section.name}
    </li>
  );

  renderSliderRhsVideoList(activeVideo) {
    const PrevArrow = sliderProps => {
      const { className } = sliderProps;
      return (
        <button
          {...sliderProps}
          className={`${s.rhs_arrows} ${s.left} ${className}`}
          aria-label="left align"
        />
      );
    };

    const NextArrow = sliderProps => {
      const { className } = sliderProps;
      return (
        <button
          {...sliderProps}
          className={`${s.rhs_arrows} ${s.right} ${className}`}
          aria-label="right align"
        />
      );
    };

    const settings = {
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />,
      infinite: false,
      dotsClass: s.rhs_dots,
    };
    const { sectionData, isFromEtimesAS } = this.props;
    const totalVideos = sectionData.items.length;
    // const middleIndex = Math.ceil(totalVideos / 2);

    const videosPerPage = isFromEtimesAS
      ? Math.ceil(totalVideos / 4)
      : Math.ceil(totalVideos / 2);

    return (
      <div className="grid_wrapper slick_UI">
        <Slider {...settings}>
          {this.props.sectionData.items
            .reduce((acc, videoItem, index) => {
              const divIndex = Math.floor(index / videosPerPage);

              if (!acc[divIndex]) {
                acc[divIndex] = [];
              }

              acc[divIndex].push(
                <Card
                  data={videoItem}
                  itemClass={`col_l_4 col_m_6 ${
                    activeVideo.id === videoItem.id ? s.vdoactive : ''
                  }`}
                  isVideoWidget
                  isVerticalTile
                  onClick={event =>
                    this.handleVideoClick(event, videoItem, index + 1)
                  }
                  key={videoItem.id}
                  imgWidth="200"
                  cssObj={{
                    imgCont: s.border_color,
                  }}
                />,
              );

              return acc;
            }, [])
            .map((divVideos, divIndex) => (
              <div key={divIndex}>{divVideos}</div>
            ))}
        </Slider>
      </div>
    );
  }

  renderRhsVideoList(activeVideo) {
    // const { sectionData = {} } = this.props;
    return (
      <div className="grid_wrapper">
        {this.props.sectionData.items.map((videoItem, index) => (
          <Card
            data={videoItem}
            itemClass={`col_l_4 col_m_6 ${
              activeVideo.id === videoItem.id ? s.vdoactive : ''
            }`}
            // videoWidget
            isVideoWidget
            isVerticalTile
            onClick={event =>
              this.handleVideoClick(event, videoItem, index + 1)
            }
            key={videoItem.id}
            imgWidth="200"
            cssObj={{
              imgCont: s.border_color,
            }}
          />
        ))}
      </div>
    );
  }
  render() {
    const { sectionData = {}, isRhsVideo } = this.props;
    const { navigation } = this.state;
    // const activeSubsection = '';
    const activeVideo = this.state.activeVideo || {};
    const initialVideo =
      this.props.sectionData.items && this.props.sectionData.items[0];

    // const pathname = window?.location?.pathname || '';
    const scrollga = `VideoPlayer_Web_TOI#View_VideoPlayerRHS#${this.gaLabel}_${
      this.label
    }_LP_${typeof window !== 'undefined' && window?.location?.href}`;
    // || sectionData.id
    const scrollGAAttr = {
      ...(sectionData.onScrollGA &&
        sectionData.id && { 'data-scrollga': scrollga }),
    };

    const sectionCls = isRhsVideo ? s.rhs_related_videos : '';
    const headerTabClassName = classNames({
      [s.headerTab]: true,
    });

    const { path: viewMorePath } = sectionData;

    return (
      <InViewObserver
        inViewCallback={() => {
          if (!this.props.isServerSideRendered) {
            this.loadNavigationData();
          }
          this.playOnLoad(); //needed in case of both server side and client side so taken outside and called
          if (this.props.isRHSWidgetPS) {
            analyticsWrapper('ga4', {
              event: 'user_shown',
              type: 'video_rhs_widget',
            });
          } else if (
            sectionData &&
            sectionData.name === 'etimes_video_widget'
          ) {
            sendGaThroughProps({
              data: {
                gaAction: 'view-RHS-videos',
                gaLabel: this.props.subSecSeoLocation,
              },
            });
          }
        }}
        viewMargin="300px 0px 300px 0px"
      >
        <div
          className={`${sectionCls} ${s.videos_section}`}
          {...scrollGAAttr}
          // data-scrollga={scrollga}
        >
          {sectionData.border &&
            sectionData.border === 'top' && (
              <InterSectionBorder border={sectionData.border} />
            )}
          <div className={headerTabClassName}>
            <div className={s.tabList}>
              {navigation?.map((section, index) =>
                this.getListItem(section, index),
              )}
              {this.props.isNavigationAbsent && sectionData.widgetTitle ? (
                <div className={s.stringHeading}>{sectionData.widgetTitle}</div>
              ) : null}
            </div>
          </div>
          <div className="grid_wrapper">
            <div className={s.videoBannerWrapper}>
              {activeVideo.id ? (
                <Video
                  msid={activeVideo.id}
                  videoClassName={`${'col_l_6 col_m_8'}`}
                  autoplay
                  slikeNextVideoAutoPlayed={this.state.slikeNextVideoAutoPlayed}
                  store={this.context.store}
                  allowDim={false}
                  slikeId={activeVideo.playerId}
                  playerType={activeVideo.playerType}
                  isUserPrime={this.props.isUserPrime}
                  source="video_widget"
                  sectionName="sidebar_listing"
                  // videoPlayListData={playListData}
                  outsideEventListener={(...args) => {
                    this.videoEventListener(...args);
                  }}
                  {...this.props.playerConfig}
                  tmplSource='videoshow'
                />
              ) : (
                <div className="col_l_6 col_m_8">
                  <Card
                    data={this.props.sectionData.items[0]}
                    itemClass={s.leadBannerImage}
                    videoWidget
                    isVideoWidget
                    isLeadVideo
                    cssObj={{
                      imgCont: s.border_color,
                    }}
                    onClick={event => {
                      event.preventDefault();
                      this.handleVideoClick(event, initialVideo);
                    }}
                    newga={`${sectionData &&
                      sectionData.name}Section_Actions#$typeClick/lead/${
                      initialVideo.wu
                    }`}
                    imgWidth="600"
                  />
                </div>
              )}
            </div>

            <div
              className={`${s.video_list} col_l_6 col_m_4 ${
                this.props.className
              }`}
              // ref={this.videoListRef}
            >
              {this.props.enableSlider
                ? this.renderSliderRhsVideoList(activeVideo)
                : this.renderRhsVideoList(activeVideo)}
              {this.props.viewMore &&
              navigation.length &&
              navigation[this.state.activeTab] ? (
                <div
                  className={s.view_more}
                  onClick={() =>
                    this.viewMore(navigation[this.state.activeTab])
                  }
                >
                  <Link
                    className={s.view_more_link}
                    to={navigation[this.state.activeTab].path}
                    target="_blank"
                    rel="noopener"
                  >
                    {sectionData && sectionData.name === 'etimes_video_widget'
                      ? 'More Videos'
                      : 'View More Videos'}
                  </Link>
                </div>
              ) : null}
              {this.props.viewMore &&
              this.props.isNavigationAbsent &&
              viewMorePath ? (
                <div
                  className={s.view_more}
                  // onClick={() =>
                  //   this.viewMore(viewMorePath)
                  // }
                >
                  <Link
                    className={s.view_more_link}
                    to={viewMorePath}
                    target="_blank"
                    rel="noopener"
                  >
                    {sectionData && sectionData.name === 'etimes_video_widget'
                      ? 'More Videos'
                      : 'View More Videos'}
                  </Link>
                </div>
              ) : null}
            </div>
          </div>
          {this.props.showVideoSectionLoader && <LoaderSpinner />}
        </div>
      </InViewObserver>
    );
  }
}

const mapStateToProps = state => ({
  isMobile: state.isMobile,
  isUserPrime: state.isPrime,
  breadCrumbData: _get(state, 'header.data.navigation.breadcrumbs', []),
});

const mapDispatchToProps = dispatch => ({
  addNextVideoMsid: (msidForNextVideo, slikeId, playerId) => {
    dispatch(addNextVideoMsid(msidForNextVideo, slikeId, playerId));
  },
});

VideoWidget.propTypes = {
  sectionData: PropTypes.shape({
    data: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        hl: PropTypes.string,
        image: PropTypes.shape({}),
        du: PropTypes.string,
        imageid: PropTypes.string,
        wu: PropTypes.string,
        items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
      }),
    ),
    items: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        playerId: PropTypes.string,
        playerType: PropTypes.string,
      }),
    ).isRequired,
  }).isRequired,
  loadAjaxSectionData: PropTypes.func,
  addNextVideoMsid: PropTypes.func.isRequired,
  showVideoSectionLoader: PropTypes.bool,
  className: PropTypes.string,
  isRhsVideo: PropTypes.bool,
  isUserPrime: PropTypes.bool,
  viewMore: PropTypes.bool,
  playerConfig: PropTypes.shape({
    playOnLoad: PropTypes.bool,
  }),
  isRHSWidgetAS: PropTypes.bool,
  isRHSWidgetLB: PropTypes.bool,
  isRHSWidgetPS: PropTypes.bool,
  breadCrumbData: PropTypes.arrayOf(),
  isMobile: PropTypes.bool,
  isNavigationAbsent: PropTypes.bool,
  isServerSideRendered: PropTypes.bool,
  enableSlider: PropTypes.bool,
  subSecSeoLocation: PropTypes.string,
};

VideoWidget.defaultProps = {
  viewMore: false,
  showVideoSectionLoader: false,
  className: '',
  isRhsVideo: false,
  loadAjaxSectionData: undefined,
  isUserPrime: false,
  playerConfig: {
    playOnLoad: false,
  },
  isRHSWidgetAS: false,
  isRHSWidgetLB: false,
  isRHSWidgetPS: false,
  breadCrumbData: [],
  isMobile: false,
  isNavigationAbsent: false,
  isServerSideRendered: false,
  enableSlider: false,
  subSecSeoLocation: '',
};

VideoWidget.contextTypes = {
  store: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(VideoWidget);
